// extracted by mini-css-extract-plugin
export default {"support-form":"Form_support-form__V-jPh","error-message":"Form_error-message__hPmIW","sent-message":"Form_sent-message__XaxbN"};